// Utilitários de data pequenos o bastante pra não justificar uma dependência (date-fns/dayjs) só
// pra grid de mês/semana — tudo aqui trabalha em horário local do navegador.

const NOMES_DIA = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const NOMES_MES = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export { NOMES_DIA, NOMES_MES };

export function inicioDoDia(data: Date): Date {
  const d = new Date(data);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function fimDoDia(data: Date): Date {
  const d = new Date(data);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function somarDias(data: Date, dias: number): Date {
  const d = new Date(data);
  d.setDate(d.getDate() + dias);
  return d;
}

export function inicioDaSemana(data: Date): Date {
  return somarDias(inicioDoDia(data), -data.getDay());
}

export function inicioDoMes(data: Date): Date {
  return new Date(data.getFullYear(), data.getMonth(), 1);
}

export function fimDoMes(data: Date): Date {
  return new Date(data.getFullYear(), data.getMonth() + 1, 0, 23, 59, 59, 999);
}

/** Grade de 6 semanas x 7 dias cobrindo o mês (com dias de meses vizinhos preenchendo as pontas). */
export function gradeDoMes(referencia: Date): Date[] {
  const inicio = inicioDaSemana(inicioDoMes(referencia));
  return Array.from({ length: 42 }, (_, i) => somarDias(inicio, i));
}

export function gradeDaSemana(referencia: Date): Date[] {
  const inicio = inicioDaSemana(referencia);
  return Array.from({ length: 7 }, (_, i) => somarDias(inicio, i));
}

export function mesmoDia(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

